import React, { Component } from 'react';
import { changeTitle } from "$actions/root";
import { connect } from 'react-redux';
import { Show } from '$components/project/index';
import { Translate } from '$common';

@connect(null, { changeTitle })
export default class ShowRoute extends Component {

  componentWillMount() {
    this.props.changeTitle(Translate.get('projects'))
  }

  render() {
    const { project, activityMap, submissions, createReport } = this.props;

    return (
      <Show
        project={project}
        activityMap={activityMap}
        submissions={submissions}
        createReport={createReport}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/project/show/show.js